const getFlattenedParts = (parts, exclude = 'none') => {
    let result = [];
    Object.keys(parts).forEach((partSection) => {
        if (partSection !== exclude) {
            switch (partSection) {
                case 'engine':
                case 'paintwork':
                    if (parts[partSection] !== null) {
                        result.push(parts[partSection].data);
                    }
                    break;
                default:
                    if (parts[partSection] !== null) {
                        result = result.concat(parts[partSection].data);
                    }
            }
        }
    });
    return result;
};
export default getFlattenedParts;
